export default {
  "smartwitnessVideo_deviceOffline": "The vehicle is currently offline - unable to fetch media",
  "smartwitnessVideo_viewCameraEvents": "View Camera Events",
  "smartwitnessVideo_saved": "Saved successfully",
  "smartwitnessVideo_notEsn": "Not ESN available - unable to fetch media"
};